import { createDomElementHandler } from '@/scripts/utils/dom.utils';
import type { PurchaseScope } from '@/scripts/components/purchase-cta/purchaseCta.model';

export function createProductSpecsLink(id: string, purchaseScope?: PurchaseScope, options: {
  label?: string; classes?: string[]; href?: string;
} = {}) {
  const link = createDomElementHandler('a', options.classes ?? ['ab-btn', 'ab-btn--outline'], {
    href: options.href ?? '#',
    'ab-hot-link': 'open-data-sheet',
    'ab-hot-link-options': JSON.stringify({ productIds: id,
      ...(purchaseScope ? { purchaseScopes: { [id]: purchaseScope } } : {}),
    }),
  });
  link.textContent = options.label ?? 'Scheda tecnica';
  return link;
}
